import React from "react";
import { connect } from "react-redux";

import { getUserPermissionById, setIsOpenDialog } from "../../redux";
import { HubButton } from "../inputs";
import { HubContextMenu } from "../HubContextMenu";
import {
  PERMISSION_LEVEL_KEYS,
  PERMISSIONS_KEY,
} from "../../constants/permissions";
import { useNavigate } from "react-router-dom";

const Part = {
  id: "part",
  label: "Part",
  icon: "Settings",
  name: "create-customer-part",
};

const Customer = {
  id: "customer",
  label: "Customer",
  icon: "Users",
  name: "create-company",
};

const Order = {
  id: "order",
  label: "Order",
  icon: "FileText",
  name: "purchase-order-create",
};

const Labor = {
  id: "labor",
  label: "Labor Ticket",
  icon: "CreditCard",
  name: "create-labor-ticket",
};

const Shipment = {
  id: "shipment",
  label: "Shipment",
  icon: "Archive",
  name: "edit-shipping-details",
};

const Quote = {
  id: "quote",
  label: "Quote",
  icon: "FileText",
  page: "/quotes",
};

const CreateObjectButton = ({
  _setIsOpenDialog = () => {},
  parts,
  customers,
  orders,
  labor,
  shipments,
  quotes,
  ...rest
}) => {
  const navigate = useNavigate();

  const MENU_ITEMS = [
    parts && Part,
    customers && Customer,
    orders && Order,
    labor && Labor,
    shipments && Shipment,
    quotes && Quote,
  ].filter(Boolean);

  const onSelect = (item) => {
    if (item?.name) _setIsOpenDialog(item?.name, true);
    if (item?.page) navigate(item?.page);
  };

  const isSolo = MENU_ITEMS.length === 1;
  const onClick = () => {
    if (isSolo) onSelect(MENU_ITEMS[0]);
    return;
  };

  const MenuButton = (
    <HubButton
      label="Create"
      icon="Plus"
      variant="contained"
      size="xsmall"
      sx={{ fontSize: 11 }}
      onClick={onClick}
    />
  );

  if (isSolo) return MenuButton;

  return (
    <HubContextMenu
      id={"orders"}
      loading={false}
      menuItems={MENU_ITEMS}
      menuButton={MenuButton}
      onSelect={onSelect}
      IconButtonProps={{
        sx: {
          padding: "0px !important",
        },
      }}
      {...rest}
    />
  );
};

const mapStateToProps = (state) => {
  const getPermission = (key) =>
    getUserPermissionById(state, key, PERMISSION_LEVEL_KEYS.CREATE);

  return {
    parts: getPermission(PERMISSIONS_KEY.PARTS),
    customers: getPermission(PERMISSIONS_KEY.CUSTOMERS),
    orders: getPermission(PERMISSIONS_KEY.ORDERS),
    labor: getPermission(PERMISSIONS_KEY.TICKETS),
    shipments: getPermission(PERMISSIONS_KEY.SHIPMENTS),
    quotes: getPermission(PERMISSIONS_KEY.SALES),
  };
};
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};

export const CreateButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateObjectButton);
export default CreateButton;
